import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import styles from "./AddAuditModal.module.scss";

import Modal from "components/Modal/Modal";
import FormElement from "components/FormElement/FormElement";
import Select from "components/Select/Select";
import Button from "components/Button/Button";
import {
    loadActsAction,
    loadSitesAction,
    createAuditAction
} from "store/actions/Actions";

const AddAuditModal = props => {
    const [state, setState] = useState({
        act: "",
        site: "",
        name: ""
    });

    const [stateErrors, setStateErrors] = useState({
        act: "",
        site: "",
        audit_name: ""
    });

    const { SitesReducer, ActsReducer, UserOrgSiteReducer, loadSitesAction, loadActsAction } = props;

    useEffect(() => {
        if (!SitesReducer.sites) {
            loadSitesAction();
        }
    }, [SitesReducer.sites, loadSitesAction]);

    useEffect(() => {
        if (!ActsReducer.acts) {
            loadActsAction();
        }
    }, [ActsReducer.acts, loadActsAction]);

    const isOrgWide = (actId) => {
        try {
            if (ActsReducer.acts && actId && ActsReducer.acts.filter(item => item.id === `${actId}`)[0].org_wide === "t") {
                return true;
            }
        } catch (error) {
            console.log('error isOrgWide');
        }
        return false;
    }

    const addModal = (e) => {
        if ((isOrgWide(state.act)) && state.name !== '' && state.act !== '') {
            props.createAuditAction({ name: state.name, act: state.act, });
            props.setShowModal(false);
            return false;   
        }
        if (state.site === "" || state.act === "") {
            setStateErrors((s) => ({
                ...s,
                site: state.site === "" ? "Site is required" : "",
                act: state.act === "" ? "Act is required" : "",
            }));
            return false;
        }

        props.createAuditAction({ name: state.name, act: state.act, site: state.site });
        props.setShowModal(false);
    }

    const handleActSelect = (e) => {
        e.persist();
        setState((s) => ({
            ...s,
            act: e.target.value,
            name: e.target.textContent,
        }));
        setStateErrors((s) => ({ ...s, act: '', site: '' }));
    };

    const handleSiteSelect = (e) => {
        e.persist();
        setState((s) => ({
            ...s,
            site: e.target.value,
        }));
        setStateErrors((s) => ({ ...s, site: '' }));
    };

    const is_site_admin = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_site_admin) || false;

    const sitesList = {};
    sitesList[0] = "All";
    SitesReducer.sites && SitesReducer.sites.forEach(site => {
        sitesList[site.id] = site.name;
    });

    const actsList = {};
    ActsReducer.acts && ActsReducer.acts.forEach(act => {
        actsList[act.id] = act.name;
    });

    return (
        <Modal className={styles.modal} setShowModal={props.setShowModal}>
            <p className={styles["modal-heading"]}>Add Audit</p>
            <div className={styles["modal-content"]}>
                {ActsReducer.acts && <>
                <FormElement
                    className={styles["regulatory-act"]}
                    labelText="REGULATORY ACT"
                    htmlFor="regulatory-act"
                    errorMessage={stateErrors.act}
                >
                    <Select
                        value={state.act}
                        placeholder="Regulatory Act"
                        onClick={handleActSelect}
                        labels={actsList}
                        dropdownToggleRef={props.actDropdownRef || null}
                    >
                        {ActsReducer.acts && ActsReducer.acts.map(act => <li key={`actid-${act.id}`} value={act.id}>{act.name}</li>)}
                    </Select>
                </FormElement>

                <br />

                {(state.act && !isOrgWide(state.act)) &&
                <FormElement
                    className={styles["site"]}
                    labelText="SITE"
                    htmlFor="site"
                    errorMessage={stateErrors.site}
                >
                    <Select
                        value={state.site}
                        placeholder="Site"
                        onClick={handleSiteSelect}
                        labels={sitesList}
                        dropdownToggleRef={props.siteDropdownRef || null}
                    >
                        {!is_site_admin && <li key={`siteid-all`} value={0}>All</li>}
                        {SitesReducer.sites && SitesReducer.sites.map(site => <li key={`siteid-${site.id}`} value={site.id}>{site.name}</li>)}
                    </Select>
                </FormElement>
                }
                </>}
            </div>

            <div className={styles["modal-footer"]}>
                <Button
                    text="CANCEL"
                    color="secondary"
                    onClick={() => props.setShowModal(false)}
                />
                <Button
                    text="CREATE"
                    className={styles.create}
                    onClick={(e) => addModal(e)}
                />
            </div>
        </Modal>
    );
};

const mapStateToProps = ({
    ActsReducer,
    SitesReducer,
    CreateAuditReducer,
    UserOrgSiteReducer
}) => ({
    ActsReducer,
    SitesReducer,
    CreateAuditReducer,
    UserOrgSiteReducer
});

const mapDispatchToProps = {
    loadActsAction,
    loadSitesAction,
    createAuditAction
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddAuditModal);
